//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BirthdayWishes from '../birthdayWishes';

export default {
    name: 'birthdaySettingInfo',
    components: { BirthdayWishes },
    data() {
        return {

            ruleId: 0,
            loading: false,
            saving: false,
            birthdayRule: {},
            checkAllGroup: [],
            cityRanges: [],
            name: 'name1'
        };
    },
    methods: {
        getRule() {
            this.loading = true;
            abp.ajax.get('/api/services/app/Birthday/GetRuleById?id=' + this.ruleId).then(res => {
                this.birthdayRule = {
                    memberLevel: ''
                };
                this.birthdayRule = res.data.result;
                this.cityRanges = [];
                this.checkAllGroup = [];
                this.isEditRange = false;
                // this.birthdayRule = JSON.parse(JSON.stringify(d));
                this.cityRanges = this.birthdayRule.cityRanges;
                if (this.birthdayRule && this.birthdayRule.memberLevel.length > 0) {
                    this.checkAllGroup = this.birthdayRule.memberLevel.split(',');
                }

            }).finally(() => {
                this.loading = false;
            });
        },
        tabClicked(val) {
            this.name = val;
        },
        pageChange() {
            this.$refs.birthdayWishesRef.pageChange(1);
        },
        onRelease() {
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认审核吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    this.saving = true;
                    abp.ajax.post('/api/services/app/Birthday/ReleaseById?id=' + this.ruleId).then(res => {
                        // this.showBirthdaySettingModal = false;
                        this.getRule();
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        onCancelAudit() {
            var vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认取消审核吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    vm.saving = true;
                    abp.ajax.post('/api/services/app/Birthday/CancelAudit?id=' + vm.ruleId).then(res => {
                        // this.showBirthdaySettingModal = false;
                        vm.getRule();
                    }).finally(() => {
                        vm.saving = false;
                    });
                }
            });
        },
        delRule() {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除' + vm.birthdayRule.name + '吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    vm.saving = true;
                    abp.ajax.delete('/api/services/app/Birthday/DeleteRule?id=' + vm.ruleId).then(res => {
                        // vm.getRule();
                        vm.$router.push({ name: 'birthdaySetting' });
                    }).finally(() => {
                        vm.saving = false;
                    });
                }
            });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.ruleId = parseInt(this.$route.params.ruleId) || 0;
        if (this.ruleId > 0) {
            this.getRule();
        }
    }
};
